import { useEffect } from 'react';

// Shared by every mounted caller, so stacked modals unlock only when the last
// one closes.
let lockCount = 0;
let previousOverflow = '';

/** Stops the page behind a modal from scrolling while the caller is mounted. */
const useBodyScrollLock = () => {
  useEffect(() => {
    if (lockCount === 0) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
    }
    lockCount += 1;
    return () => {
      lockCount -= 1;
      if (lockCount === 0) document.body.style.overflow = previousOverflow;
    };
  }, []);
};

export default useBodyScrollLock;
